export default {
    tips: [],
    loading: false
};
